import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gallery-thumbs" }

import {useStore} from '../store';
import GalleryThumbnail from './GalleryThumbnail.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryThumbnails',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).images, (image, index) => {
      return (_openBlock(), _createBlock(GalleryThumbnail, {
        key: index,
        index: index,
        image: image
      }, null, 8 /* PROPS */, ["index", "image"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})